import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const EVInsider = ({ size, color, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '40px'}
      height={size || '40px'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 40 40"
      fill={color || 'currentColor'}
    >
      <svg
        width="40"
        height="40"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_893_148230)">
          <path
            d="M4.93945 0L6.50945 1.2H12.4195V10.73H12.3995V11.94H13.6195V0H4.93945Z"
            fill="#757575"
          />
          <path
            d="M9.10086 16.0001L3.38086 11.5701V0.370117L9.10086 4.80012V16.0001ZM4.50086 11.0201L7.98086 13.7201V5.34012L4.50086 2.64012V11.0101V11.0201Z"
            fill="#757575"
          />
        </g>
        <defs>
          <clipPath id="clip0_893_148230">
            <rect width="16" height="16" fill="white" transform="translate(0.5)" />
          </clipPath>
        </defs>
      </svg>
    </StyledSvg>
  );
};
